import { object, string, nativeEnum } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { IS_REQUIRED, IS_VALID } from '@occc-app/lib/constants/validationMessages';
import { User_Role } from '@occc/graphql';

export const userSchema = object({
  firstName: string({ required_error: IS_REQUIRED }),
  lastName: string({ required_error: IS_REQUIRED }),
  email: string({ required_error: IS_REQUIRED }).email(IS_VALID),
  userRole: nativeEnum(User_Role, { required_error: IS_REQUIRED }),
});

export const validateUser = makeValidate(userSchema);
